// eslint-disable-next-line no-process-env
const version = process.env.VERSION;

module.exports = {
  version,
  storageKeys: {
    main: 'store',
    requests: 'requests',
  },
  api: {
    url: `/api/${version}`,
    endpoints: {
      search: {
        settings: 'search/settings',
        search: 'search',
      },
    },
  },
};
